import React, { useContext, useRef } from 'react';
import { ViewContext, Form } from 'components/lib';
import { CSSTransition } from 'react-transition-group';
import './modal.scss';

// Ícono por defecto para los modales de formulario (crear / editar).
const DefaultModalIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" />
  </svg>
);

// Los modales destructivos también llevan icono, pero de advertencia.
const DestructiveModalIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3 2 20h20L12 3z" />
    <line x1="12" y1="10" x2="12" y2="14" /><line x1="12" y1="17.3" x2="12" y2="17.3" />
  </svg>
);

export function Modal(props) {
  const context = useContext(ViewContext);
  const nodeRef = useRef(null);

  // Todos los modales llevan la misma cabecera: icono + título + subtítulo.
  const defaultIcon = props.destructive ? <DestructiveModalIcon /> : <DefaultModalIcon />;

  return (
    <CSSTransition in appear timeout={0} classNames="modal" nodeRef={nodeRef}>
      <div
        ref={nodeRef}
        className="modal"
      >
        <div className="modal-content">
          <button
            className="modal-close"
            onClick={() => context.modal.hide(true)}
            aria-label="Cerrar"
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
            </svg>
          </button>
          {props.title && (
            <div className="modal-header">
              <div className="modal-header-icon">
                {props.icon || defaultIcon}
              </div>
              <div className="modal-header-text">
                <h2 className="modal-title">{props.title}</h2>
                {props.subtitle && <p className="modal-subtitle">{props.subtitle}</p>}
              </div>
            </div>
          )}

          <div className={`modal-body${props.component ? ' modal-has-component' : ''}`}>
            {props.text && <p>{props.text}</p>}
            {props.body && <div>{props.body}</div>}
            {props.component && props.component}
            {props.form && (
              <Form
                numberGrid={props.numberGrid}
                method={props.method}
                url={props.url}
                data={props.form}
                destructive={props.destructive}
                buttonText={props.buttonText}
                buttonTextCancel={props.buttonTextCancel}
                suppressSuccessMessage={props.suppressSuccessMessage}
                cancel={(e) => context.modal.hide(true)}
              />
            )}
          </div>
        </div>
      </div>
    </CSSTransition>
  );
}
